import { IsBoolean, IsISO8601, IsOptional, IsString, MaxLength } from 'class-validator';

export class UpdateTenantClosurePeriodDto {
  @IsISO8601({ strict: true })
  @IsOptional()
  startDate?: string;

  @IsISO8601({ strict: true })
  @IsOptional()
  endDate?: string;

  @IsString()
  @IsOptional()
  @MaxLength(120)
  label?: string;

  @IsBoolean()
  @IsOptional()
  recurringYearly?: boolean;
}
